<template>
	<q-card
		class="full-width full-height shadow-transition relative-position card-presential cursor-pointer"
		:class="class_hover"
		@mouseover="setClassHover('mouseover')"
		@mouseleave="setClassHover('mouseleave')"
	>
		<div class="q-img">
			<div class="img">
				<img
					class="full-width"
					:src="getImage"
					@error="getImageError"
					:alt="getAltImage"
					@click="openPresential()"
				/>
			</div>
		</div>

		<q-card-section>
			<div class="row">
				<div :class="showSubscribeButton ? 'col-8' : 'col-12'" @click="openPresential()">
					<div class="row">
						<div class="col-12 text-h4">
							{{ $dateUtil.fDay(presential.event_dates[0].event_date) }}
						</div>

						<div class="col-12 text-h6 text-weight-regular" style="line-height: 1rem">
							{{ $dateUtil.fMonth(presential.event_dates[0].event_date) }}
						</div>

						<div class="col-12">
							{{ $t('at') }}
							{{
								$dateUtil.fTimeTimezoneFormated(
									presential.event_dates[0].hr_start,
									presential.timezone
								)
							}}
							<span class="text-caption text-weight-light"
								>(GMT{{ $dateUtil.timezoneHuman(presential.timezone) }})</span
							>
						</div>

						<div class="col-12" v-if="presential.event_dates?.length > 1">
							{{
								$t('and_more_dates', {
									count: presential.event_dates?.length - 1,
									dates: presential.event_dates?.length - 1,
								})
							}}

							<q-tooltip>
								<span v-for="date in presential.event_dates.slice(1)">
									{{ $dateUtil.fDateTimezoneFormated(date.event_date, presential.timezone) }}
									{{ $t('at') }} {{ $dateUtil.fHourNoTimezone(date.hr_start) }} (GMT{{
										$dateUtil.timezoneHuman(presential.timezone)
									}})<br />
								</span>
							</q-tooltip>
						</div>

						<div class="col-12" v-else>&nbsp;</div>
					</div>
				</div>

				<div class="col-4 text-right" v-if="showSubscribeButton && !disableEvent">
					<q-btn
						flat
						round
						dense
						:color="subscribeButtonColor"
						:icon="subscribeButtonIcon"
						@click="confirmSubscribePresential()"
					>
						<q-tooltip>
							{{
								$t(subscribeButtonLabel, {
									catalog: presential?.code ? `(${presential.code})` : '',
								})
							}}
						</q-tooltip>
					</q-btn>
				</div>
			</div>
		</q-card-section>

		<q-card-section @click="openPresential()" class="q-py-sm">
			<div class="text-subtitle2 title">
				{{ presential.title }}
			</div>

			<div class="text-subtitle2 title">
				{{ showCatalog && presential.code ? presential.code : '&nbsp;' }}
			</div>
		</q-card-section>

		<q-card-actions class="text-grey-5 q-py-sm">
			<div class="row full-width q-col-gutter-sm">
				<div class="col-12 text-center">
					<q-btn size="sm" dense flat no-caps icon="fal fa-trophy" v-if="$hasScore()">
						<q-tooltip>
							{{ $t('points', { count: presential.score }) }}
						</q-tooltip>
						<span class="q-pl-xs">{{ presential.score }}</span>
					</q-btn>

					<q-btn size="sm" dense flat no-caps icon="fal fa-clock" v-if="presential.workload">
						<q-tooltip>
							<template>
								{{ $t('workload') }}
							</template>
						</q-tooltip>
						<span class="q-pl-xs">{{ presential.workload }}</span>
					</q-btn>

					<q-btn
						size="sm"
						dense
						flat
						no-caps
						:icon="presential.starred ? 'fas fa-star' : 'far fa-star'"
						@click="toggleReviews()"
						v-if="useReviews"
					>
						<q-tooltip>
							{{ $t('reviews') }}
						</q-tooltip>

						<span class="q-pl-xs">{{ presential.avg_stars.toFixed(1) }}</span>
					</q-btn>

					<q-btn
						size="sm"
						dense
						flat
						no-caps
						:icon="presential.liked ? 'fas fa-thumbs-up' : 'far fa-thumbs-up'"
						@click="likePresential()"
					>
						<q-tooltip>
							<template v-if="!presential.liked">
								{{ $t('like') }}
							</template>

							<template v-else>
								{{ $t('unlike') }}
							</template>
						</q-tooltip>

						<span class="q-pl-xs">{{ presential.likes }}</span>
					</q-btn>
				</div>
			</div>
		</q-card-actions>

		<q-inner-loading :showing="loading">
			<q-spinner-facebook size="1rem" color="text-blue-grey-4" />
		</q-inner-loading>

		<q-tooltip anchor="center middle" self="top middle" v-if="disableEvent">
			{{ $t('you_already_have_a_certificate_for_this_type_of_event') }}
		</q-tooltip>
	</q-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'PresentialCardDesktop',

	props: ['presential'],

	data() {
		return {
			class_hover: '',
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			country_areas: 'site_lists/country_areas',
			groups_user: 'site_lists/groups_user',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		showCatalog() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})
			if (obj) return obj.presential_event_catalog
			else return false
		},

		allowSingleCertificationPerCatalogConfig() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})
			if (obj) return obj.allow_single_certification_per_catalog
			else return false
		},

		getImage() {
			const image = this.presential.presential_event_images.find((e) => e.name === 'large')
			if (image) return image.image_url
			else {
				let obj = this.clients.find((obj) => obj.id == this.id_user_client_selected)
				if (obj) return obj.presential_event_placeholder
				else return ''
			}
		},

		getAltImage() {
			if (this.presential.presential_image_alt_texts?.length) {
				return this.presential.presential_image_alt_texts[0].alt_text
			}
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) {
				if (obj.presential_event_placeholder_alt_text != '')
					return obj.presential_event_placeholder_alt_text
			} else return ''
		},

		showSubscribeButton() {
			let diff = this.$dateUtil.dateDiffereceTimezoneDays(this.presential.event_dates[0].hr_start)
			let same_day = this.$dateUtil.isSameDay(this.presential.event_dates[0].hr_start)

			if (same_day) {
				if (diff < -1) return false
				else return true
			} else {
				if (diff < 0) return false
				else return true
			}
		},

		subscribeButtonLabel() {
			let diff = this.$dateUtil.dateDifferece(this.presential.event_dates[0].hr_start)

			if (!this.presential.user_subscribed && this.presential.qty_vacancies <= 0) {
				return 'no_vacancy'
			} else if (diff < 0) {
				if (this.presential.status === 3) return 'in_progress'
				else if (this.presential.status === 4) return 'intermission'
				else if (this.presential.presential_event_user_result_status === 1) return 'approved'
				else if (this.presential.presential_event_user_result_status === 2) return 'reproved'
				else return 'transmission_finished'
			} else {
				if (this.presential.presential_event_type_slug === 'closed') return 'registered'
				else {
					if (!this.presential.user_subscribed) {
						if (
							this.allowSingleCertificationPerCatalogConfig &&
							!this.presential.allow_subscription
						)
							return 'you_already_have_a_certificate_in_one_event_on_this_catalog'
						else return 'subscribe'
					} else {
						return 'unsubscribe'
					}
				}
			}
		},

		subscribeButtonIcon() {
			let diff = this.$dateUtil.dateDifferece(this.presential.event_dates[0].hr_start)

			if (!this.presential.user_subscribed && this.presential.qty_vacancies <= 0) {
				return 'fal fa-users-slash'
			} else if (diff < 0) {
				if (this.presential.status === 3) return 'fal fa-broadcast-tower'
				else if (this.presential.status === 4) return 'fal fa-pause'
				else if (this.presential.presential_event_user_result_status === 1)
					return 'fal fa-badge-check'
				else if (this.presential.presential_event_user_result_status === 2) return 'fal fa-ban'
				else return 'fal fa-video'
			} else {
				if (this.presential.presential_event_type_slug === 'closed') {
					return 'fal fa-calendar-check'
				} else {
					if (!this.presential.user_subscribed) {
						if (
							this.allowSingleCertificationPerCatalogConfig &&
							!this.presential.allow_subscription
						)
							return 'fal fa-lock'
						else return 'far fa-calendar-plus'
					} else {
						return 'far fa-calendar-minus'
					}
				}
			}
		},

		subscribeButtonColor() {
			let diff = this.$dateUtil.dateDifferece(this.presential.event_dates[0].hr_start)

			if (!this.presential.user_subscribed && this.presential.qty_vacancies <= 0) {
				return 'negative'
			} else if (diff < 0) {
				if (this.presential.status === 3) return 'positive'
				else if (this.presential.status === 4) return 'warning'
				else if (this.presential.presential_event_user_result_status === 1) return 'positive'
				else if (this.presential.presential_event_user_result_status === 2) return 'negative'
				else return 'negative'
			} else {
				if (this.presential.presential_event_type_slug === 'closed') {
					return 'positive'
				} else {
					if (!this.presential.user_subscribed) {
						if (
							this.allowSingleCertificationPerCatalogConfig &&
							!this.presential.allow_subscription
						)
							return 'negative'
						return 'primary'
					} else {
						return 'secondary'
					}
				}
			}
		},

		useReviews() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})
			if (obj) return obj.use_comments_presential
			else return false
		},

		disableEvent() {
			if (
				this.$route.name !== 'presentials' &&
				!this.presential.user_is_allowed &&
				this.presential.user_progress === 0
			)
				return true
			return false
		},
	},

	methods: {
		getArea(id) {
			let obj = this.country_areas.find((obj) => {
				return obj.value === id
			})
			if (obj) return obj.label
			else return ''
		},

		getGroup(id) {
			let obj = this.groups_user.find((obj) => {
				return obj.value === id
			})
			if (obj) return obj.label
			else return ''
		},

		openPresential() {
			if (!this.disableEvent) {
				if (this.$route.name === 'presentials')
					this.$router.push({ name: 'presential', params: { id: this.presential.id } })
				else if (this.$route.name === 'presentials_catalogs')
					this.$router.push({
						name: 'trail_presential',
						params: {
							id_trail: this.$route.params.id_trail,
							id_catalog: this.$route.params.id,
							id: this.presential.id,
						},
					})
			}
		},

		confirmSubscribePresential() {
			if (
				this.presential.presential_event_type_slug === 'closed' ||
				(this.allowSingleCertificationPerCatalogConfig &&
					!this.presential.allow_subscription &&
					!this.presential.user_subscribed)
			) {
				return false
			} else {
				let diff = this.$dateUtil.dateDifferece(this.presential.event_dates[0].hr_start)

				let user_subscribed = false
				if (this.presential.presential_event_type_slug === 'closed') user_subscribed = true
				else user_subscribed = this.presential.user_subscribed

				if (!user_subscribed && this.presential.qty_vacancies <= 0) {
					return false
				} else if (diff < -0.0105 && diff > -1) {
					return false
				} else {
					this.$emit('confirmSubscribePresential', this.presential.id)
					if (this.presential.user_subscribed) {
						this.presential.qty_vacancies = this.presential.qty_vacancies + 1
					}
				}
			}
		},

		getImageError(event) {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) {
				if (
					obj.presential_event_placeholder !== 'https://image.jpg' &&
					obj.presential_event_placeholder !== ''
				)
					event.target.src = obj.presential_event_placeholder
				else event.target.src = 'placeholders/webcast.png'
			} else event.target.src = 'placeholders/webcast.png'
		},

		toggleReviews() {
			this.$emit('review', this.presential.id)
		},

		setClassHover(state) {
			if (this.disableEvent) this.class_hover = 'disabled'
			else {
				if (state === 'mouseover') this.class_hover = 'shadow-5'
				else this.class_hover = ''
			}
		},

		likePresential() {
			if (!this.is_blocked && !this.checkTrailEnrolled) this.$emit('like', this.presential.id)
		},
	},

	created() {
		if (this.disableEvent) this.class_hover = 'disabled'
	},
}
</script>

<style lang="scss" scoped>
.title {
	font-size: 0.905rem;
	line-height: 1.2rem;
	height: 38px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.hoverable-icon {
	&:hover {
		color: #000;
	}
}
.q-img {
	.img {
		padding-bottom: 56%;
		img {
			position: absolute;
			top: 0;
			left: 0;
		}
	}
}
</style>
